export const VOICE_AGENT_VOICES = [
  "Zoe",
  "Anna",
  "Peter",
  "Victoria",
  "Katherine",
  "Oliver",
  "Alexander",
  "Owen",
  "Chloe",
  "Emma",
  "Ian",
  "Lily",
  "Samuel",
  "Arthur",
  "Adam",
  "Felix",
  "Alice",
  "Ethan",
  "Aaron",
  "Diana",
  "Alan",
  "Amber",
  "Missy",
  "Zach",
  "Simon",
  "Charles",
  "Randy",
  "Laura",
  "Paul",
  "Violet",
] as const;

export type VoiceAgentVoice = (typeof VOICE_AGENT_VOICES)[number];
